import React from 'react'
// import Caro1 from '../../../Common/Components/Caro'
import ExploreRange from '../../../Common/Components/ExploreRange'
import Caro from '../../../Common/Components/HomeBanner'
import { bannerData, carCategories, carData, imagesHome } from './Data'
import Home from '../Container/homeCon'
import Cardreview from "../Container/cardsCon";
import CrissCross from './CrissCross';
import Wsp from '../../contact/Component/Floatingwsp';

export default function HOME() {
  return (
    <div>
      <Caro trim={bannerData} />
      <Home />
      {/* <Caro1 trim={imagesHome} /> */}
      <ExploreRange
        categories={carCategories}
        data={carData}
        buttonText="know more"
      />
      <CrissCross />
      <Cardreview />
      <Wsp />
    </div>
  )
}
